import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState, useCallback, Fragment } from "react";
import { componentStyles } from "./textarea-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
import FloatingLabelWrapper from "../floating-label-wrapper/floating-label-wrapper";
import { textareaFloatingLabelStyles } from "./textarea-input-floating-label.scss";
function TextareaInputFloatingLabel(props) {
    const { inputData, errorState, translate, invalid, errorLabelId, id, value } = props;
    const { inputName, isRequired, placeholder, floatingLabel } = inputData;
    const { isValid } = errorState;
    const [isFocused, setIsFocused] = useState(false);
    const [hasValue, setHasValue] = useState(!!value);
    const handleFocus = useCallback(()=>{
        setIsFocused(true);
    }, []);
    const handleBlur = useCallback((e)=>{
        const { onInputBlur } = props;
        setIsFocused(false);
        setHasValue(!!e.target.value);
        if (onInputBlur) {
            onInputBlur(e);
        }
    }, [
        props
    ]);
    const handleChange = useCallback((e)=>{
        const { onInputChange } = props;
        setHasValue(!!e.target.value);
        if (onInputChange) {
            onInputChange(e);
        }
    }, [
        props
    ]);
    const showRequiredError = (!isValid || invalid) && isRequired;
    const requiredClass = {
        "input-required": showRequiredError || invalid
    };
    const translatedPlaceholder = translate(placeholder);
    const isFloating = isFocused || hasValue || !!value;
    const translatedFloatingLabel = floatingLabel ? translate(floatingLabel) : translatedPlaceholder;
    const renderLabel = ()=>/*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: classnames("label-text placeholder-text", {
                        hidden: isFloating
                    }),
                    children: translatedPlaceholder
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: classnames("label-text floating-text", {
                        hidden: !isFloating
                    }),
                    children: translatedFloatingLabel
                })
            ]
        });
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FloatingLabelWrapper, {
                label: renderLabel(),
                htmlFor: id,
                isFocused: isFocused,
                hasValue: hasValue || !!value,
                variant: "textarea",
                children: /*#__PURE__*/ _jsx("textarea", {
                    id: id,
                    onChange: handleChange,
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    name: inputName,
                    "aria-label": translatedFloatingLabel,
                    "aria-required": isRequired,
                    "aria-invalid": invalid,
                    "aria-describedby": errorLabelId,
                    value: value,
                    className: `jsx-${textareaFloatingLabelStyles.__hash} jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash}` + " " + (classnames("hp-input hp-textarea-input", requiredClass) || "")
                })
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: commonInputStyles.__hash,
                children: commonInputStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: textareaFloatingLabelStyles.__hash,
                children: textareaFloatingLabelStyles
            })
        ]
    });
}
TextareaInputFloatingLabel.defaultProps = {
    invalid: false,
    errorLabelId: null
};
export default withGenericConfig(TextareaInputFloatingLabel);
